import React, { useContext } from 'react';
import * as S from './styled';
import { useSnackbar } from 'notistack';
import {
  defaultBlurCompanyForm,
  defaultCompanyForm,
} from '../../../../store/invoice/utils';
import Form from '../..';
import { ExportContext } from '../../../../provider/ExportProvider';

export default function FormCompanyCreate() {
  const {
    getInvoice,
    setInvoice,
    createCompany,
    setModal,
    getFormMessage,
    validateForm,
  } = useContext(ExportContext)!.controllers.company;

  const { enqueueSnackbar } = useSnackbar();

  const getForm = <T extends keyof CompanyForm>(field: T) =>
    getInvoice(`forms.companies.create.${field}`);

  const setForm = <
    T extends keyof CompanyForm,
    V extends DeepType<InvoiceState, `forms.companies.create.${T}`>,
  >(
    field: T,
    value: V,
  ) => setInvoice(`forms.companies.create.${field}`, value);

  const blurField = (field: keyof CompanyForm) => () => {
    setInvoice(`blur.companies.create.${field}`, true);
  };

  const clearForm = () => {
    setInvoice(`forms.companies.create`, defaultCompanyForm());
    setInvoice(`blur.companies.create`, defaultBlurCompanyForm());
  };

  const messages = getFormMessage('companies.create');

  const [loading, setLoading] = React.useState(false);
  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    validateForm('companies.create')
      .then(() => {
        setLoading(true);
        createCompany()
          .then((company) => {
            enqueueSnackbar('Companhia criada com sucesso', {
              variant: 'success',
            });
            clearForm();
            setModal('single.createCompany', false);
            setInvoice('filters.companies.data.data', [
              ...getInvoice('filters.companies.data.data'),
              company,
            ]);
          })
          .catch(() => {
            enqueueSnackbar('Houve uma falha ao criar a companhia', {
              variant: 'error',
            });
          })
          .finally(() => {
            setLoading(false);
          });
      })
      .catch(() => {
        enqueueSnackbar('Verifique a validade dos campos', {
          variant: 'error',
        });
      });
  };

  return (
    <S.Form
      style={{
        maxHeight: '80vh',
      }}
      onSubmit={onSubmit}
    >
      <S.Body>
        <S.Grid>
          <Form.Input
            label="Nome"
            value={getForm('name')}
            onChange={(e) => setForm('name', e.target.value)}
            error={messages.name}
            onBlur={blurField('name')}
          />
        </S.Grid>
      </S.Body>
      <S.Actions>
        <Form.Button type="button" onClick={clearForm}>
          Limpar
        </Form.Button>
        <Form.Button loading={loading}>Criar</Form.Button>
      </S.Actions>
    </S.Form>
  );
}
